(function (ws) {
    'use strict';

    ws.views.quoteRevisionsTable = ws.views.simpleTable.extend({
        /**
         * Initialize override
         */
        initialize: function(options) {
            this.$el = $('.comp-revisions');
            this.options = options;
            this.$table = this.$('#qut-revisions-table');
            this.rowTemplate = this.$('#qut-revisions-table-row');
            this.$consolidatedViewDiv = this.$('.comp-quote-conversion-consolidated-data');
            this.consolidatedView = _.template($('#comp-quote-conversion-consolidated-data').html());
            ws.views.simpleTable.prototype.initialize.call(this);
            this.controlColumn = 0;
            this.multiViewEnabled = this.$('#multiViewEnabled').val();
        },

        /**
         * Trigger search query and render table
         */
        render: function() {
            var request = {
                pageSize: 50,
                page: 0,
                searchText: this.options.quoteCode,
                searchProperty: 'revision',
                fromDate: '',
                toDate: '',
                reseller: '',
                endUserCompanyName: '',
                salesOrg:'',
                status: ''
            };

            if (isOrderEntrySite) {
                this.model.url = globals.path.api.orderentry.searchQuoteRevision;
            } else {
                this.model.url = isQuotingSite ? globals.path.api.quoting.quotesTableSearchUrl : globals.path.api.westcon.accountQuoteTableSearchUrl;
            }

            this.$apiError.hide();
            this.model.save(request).done(function(data) {
                this.$table.dataTable().fnClearTable();
                this.$table.DataTable().destroy();
                if (!isQuotingSite) {
                    const result = data.data.filter((obj) => !obj.versionID.includes('_Temp'));
                    data.paginationData.totalNumberOfResults = result.length;
                    this.calculateShowing(data.paginationData);
                    this.renderRows(result);
                } else {
                    this.renderRows(data.data);
                    this.calculateShowing(data.paginationData);
                }
            }.bind(this)).fail(function() {
                this.$apiError.show();
            });
        },

        /**
         * Render a table row (what kind of data?)
         * @param {Object} result
         */
        renderRows: function (result) {
            var options;
            var _this = this;
            _.each(result, function (row) {
                row.multiViewEnabled = _this.multiViewEnabled;

                if (_this.multiViewEnabled == 'true') {
                    _this.$consolidatedViewDiv.html(_this.consolidatedView({accountData:row.accountData}));
                }

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        }
    });
}(westcon));
